export const lang = {
    lang: '英文',
    lang1: '中文',
}
